import storage from "@/helpers/storage";

export default function numberFormatter(number) {
    const lang = storage.get('language') || 'de';
    let formatter = new Intl.NumberFormat(lang);
    return formatter.format(number);
}